import { render } from "./EntranceSchema.vue?vue&type=template&id=2bff74f6"
import script from "./EntranceSchema.vue?vue&type=script&lang=js"
export * from "./EntranceSchema.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__